// src/pages/gears/InstaX3.js

import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateAmazon from "../../components/affiliate/AffiliateAmazon";
import AffiliateEbay from "../../components/affiliate/AffiliateEbay";
import React, { useState } from "react";

// ⭐ Correct image for Insta360 X3
import x3 from "./gearimages/x3.jpg";
import x3scr from "./gearimages/x3scr.jpg";

export default function InstaX3() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "10px" }}>
        <section className="gear-review">

          <div className="gear-container">

            {/* LEFT COLUMN */}
            <div className="gear-left">
              <h1>Insta360 X3</h1>

              <p>
                The Insta360 X3 is the successor to the X2, bringing a larger 1/2” sensor,
                improved low‑light performance, and a more responsive touchscreen. It captures
                5.7K 360° video with excellent stabilization, making it ideal for action,
                travel, and creative reframing.
              </p>

              <p>
                The rugged, waterproof design (up to 10m without a case) makes it perfect for
                outdoor adventures. With upgraded audio, new shooting modes, and improved
                FlowState stabilization, the X3 is a strong upgrade for creators who want
                better image quality and more flexibility.
              </p>

              {/* ⭐ UPDATED X3 FEATURE LIST */}
              <div className="place-block">
                <ul>
                  <li>5.7K 360° video at 30fps (H.265 encoding)</li>
                  <li>1/2” larger sensor for improved low‑light performance</li>
                  <li>4K single‑lens mode for traditional action‑cam shots</li>
                  <li>FlowState stabilization with 360° horizon lock</li>
                  <li>Waterproof up to 10m (33 ft) without a case</li>
                  <li>2.29” tempered‑glass touchscreen</li>
                  <li>Upgraded 4‑mic audio with wind reduction</li>
                  <li>TimeShift, hyperlapse, and slow‑motion modes</li>
                  <li>Invisible selfie stick effect for clean 360 shots</li>
                  <li>Approx. 81 minutes of recording per charge</li>
                  <li>Full editing and reframing in the Insta360 app</li>
                </ul>
              </div>

              {/* AFFILIATE BUTTONS */}
              <AffiliateAmazon
                title="Check price on Amazon"
                link="https://amzn.to/4ssEVyv"
              />

              <AffiliateEbay
              title="Check price on eBay"
                link="https://ebay.us/1qOqDg"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="gear-right">
              <img src={x3} alt="Insta360 X3 camera" />
              <img src={x3scr} alt="Insta360 X3 screen" />
            </div>

          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
